import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { PresetService } from 'src/app/core/services/preset.service';
import { delay } from 'rxjs/internal/operators';
import { NgbModalRef, NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Role } from 'src/app/core/models/role';
import { PremiumTargetsPopupComponent } from '../../modals/premium-targets-popup/premium-targets-popup.component';


@Component({
  selector: 'app-profile-presets-list',
  templateUrl: './profile-presets-list.component.html',
  styleUrls: ['./profile-presets-list.component.css']
})
export class ProfilePresetsListComponent implements OnInit {


  @Output() addItem = new EventEmitter<any>();
  @Output() deletePresetItem = new EventEmitter<any>();
  @Output() editPresetItem = new EventEmitter<any>();
  @Input() secondProfilesOnThePage: boolean;
  @Input() title: string;
  @Input() noDataMsg: string;
  @Input() darkMode: boolean;
  @Input() canUseConfigurator: boolean = false;
  @Input() canUseScalingConfigurator: boolean = false;
  @Input() canUsePremiumTargets: boolean = false;
  @Input() clientId: string;


  presetsList: any = [];
  userPresets: any = [];
  presetsSearch: any = [];
  searchPresetParam: string;
  searchPresetsParam: string;
  selectedPreset = 'Select Preset...';
  selectedPresets: any = [];
  showPresets: boolean;

  presetToDelete: any;
  presetToEdit: any;
  modalDeletePreset: NgbModalRef;
  modalSetPreset: NgbModalRef;

  currentUser: any = [];

  @ViewChild('dialogScaleFactor') public dialogScaleFactor: TemplateRef<any>;

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal'
  };

  constructor(
    private presetService: PresetService,
    private modalService: NgbModal,
    private authService: AuthService,
    private translate: TranslateService,
    private toastr: ToastrService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.authService.LoggedinUser
      .subscribe(
        user => {
          this.currentUser = user;
        }
      );
    this.translate.get(['user.selectPreset']).subscribe((values) => {
      this.selectedPreset = values['user.selectPreset'];
    });
    if (this.secondProfilesOnThePage) {
      this.loadPresets2();
    } else {
      this.loadPresets();
    }
    console.log(this.router.url)
  }

  loadPresets() {
    this.presetService.allPresets.subscribe(
      (presets) => {
        this.presetsList = presets;
        this.presetsSearch = presets;
      }
    )
    this.presetService.selectedPresets.subscribe(
      (presets) => {
        this.userPresets = presets;
      }
    )
  }

  loadPresets2() {
    this.presetService.allPresets2$.pipe(
      delay(500)).subscribe(
      (presets) => {
        this.presetsList = presets;
        this.presetsSearch = presets;
      }
    );
    this.presetService.selectedPresets2$.pipe(
      delay(500)).subscribe(
      (presets) => {
        this.userPresets = presets;
      }
    )
  }

  openPresets() {
    this.showPresets = !this.showPresets;
    this.searchPresetsParam = '';
    this.presetsSearch = this.presetsList;
    this.applyPresetFilter();
  }
  selectedPresetId: any;
  addPreset(presetId) {
    const isAssigned = this.userPresets?.some(preset => preset.id === presetId);
    if (isAssigned) {
      this.translate.get('errors.presetIsAlreadyAssigned').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }
    this.addItem.emit(presetId);
  }

  addPresetAsRoot(form:NgForm) {
    let scale_factor = form.form.value.scale_factor;
    let presetId = this.selectedPresetId;
    let data = {
      scale_factor,
      presetId
    }
    this.addItem.emit(data);
    this.modalSetPreset.close();
  }

  editPreset(form:NgForm) {
    if (!form.valid) {
      this.translate.get('errors.pleaseFillRequiredFields').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }
    let scale_factor = form.form.value.scale_factor;
    let presetId = this.presetToEdit.id;
    let data = {
      scale_factor,
      presetId
    }
    this.editPresetItem.emit(data);
    this.modalSetPreset.close();
  }

  showDialogEditPreset(content, file?: any) {
    this.presetToEdit = file;
    this. modalSetPreset = this.modalService.open(content, this.dialogOptions);
  }

  applyPresetFilter() {
    this.presetsSearch = this.presetsList.filter(preset =>
      preset.name.toLowerCase().includes(this.searchPresetParam.toLowerCase())
    );
  }

  removePresetItem(id: string) {
    this.selectedPresets.forEach(bg => {
      if (bg.id === id) {
        const index = this.selectedPresets.indexOf(bg);
        if (index > -1) {
          this.selectedPresets.splice(index, 1);
        }

      }
    });
  }

  showDialogDeletePreset(content, file: any) {
    this.presetToDelete = file;
    this.modalDeletePreset = this.modalService.open(content, this.dialogOptions);
  }

  deletePreset() {
    this.deletePresetItem.emit(this.presetToDelete.id);
    this.userPresets.splice(this.userPresets.findIndex(preset => preset.id == this.presetToDelete.id), 1);
    this.secondProfilesOnThePage ? this.presetService.setSelected2Presets(this.userPresets) : this.presetService.setSelectedPresets(this.userPresets);
    this.modalDeletePreset.close();
  }

  presetPage = 1;
  presetPerPage = 8;
  jumpToPresetsPage(event: any) {
    this.presetPage = event;
  }

  navigateToConfigurator() {
    if (this.currentUser.role.name === Role.CUSTOMER) {
      this.router.navigate([
        `/customer/clients/${this.clientId}/fillable-image-configurator`,
      ]);
    } else if (this.currentUser.role.name === Role.ROOT) {
      this.router.navigate([`/root/clients/${this.clientId}/fillable-image-configurator`]);
    }
  }

  navigateToScalingConfigurator() {
    if (this.currentUser.role.name === Role.ROOT) {
      this.router.navigate([`/root/clients/${this.clientId}/scale-image-configurator`]);
    }
  }

  navigateToVideoConfigurator() {
    if (this.currentUser.role.name === Role.ROOT) {
      this.router.navigate([`/root/clients/${this.clientId}/premium-video-configs`]);
    }
  }

  openPremiumTargetsPopup() {
    const modalRef = this.modalService.open(PremiumTargetsPopupComponent, {
      ...this.dialogOptions,
      size: 'lg',
    });
    modalRef.componentInstance.clientId = this.clientId;
    modalRef.componentInstance.isPremiumEnabled = this.canUsePremiumTargets;
  }
}
